import { Injectable } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CommonAction } from './common.action';
import { ApiService } from '../service/api.service';
var BulkAction = /** @class */ (function () {
    function BulkAction(commonAction, api) {
        this.commonAction = commonAction;
        this.api = api;
    }
    BulkAction.prototype.exec = function (params, rec) {
        var sources = [];
        if (params.targetComponent && typeof rec['items'] !== 'undefined' && rec['items'] instanceof Array) {
            var items = rec['items'];
            var paramsStr = JSON.stringify(params);
            var _loop_1 = function (item) {
                var _params = this_1.commonAction.replaceParams(JSOG.parse(paramsStr), {}, item);
                sources.push(this_1.api.execApi(_params, _params.url, item, {}).pipe(map(function (data) { return ({ rec: item, res: data }); }), catchError(function (error) { return of({ rec: item, error: error }); })));
            };
            var this_1 = this;
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                _loop_1(item);
            }
        }
        return forkJoin(sources);
    };
    BulkAction.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    BulkAction.ctorParameters = function () { return [
        { type: CommonAction },
        { type: ApiService }
    ]; };
    return BulkAction;
}());
export { BulkAction };
var Bulk = /** @class */ (function () {
    function Bulk() {
    }
    return Bulk;
}());
//# sourceMappingURL=bulk.action.js.map